import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Studio\WatermarkController::show
* @see app/Http/Controllers/Studio/WatermarkController.php:35
* @route '/studio/watermark'
*/
export const show = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/studio/watermark',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Studio\WatermarkController::show
* @see app/Http/Controllers/Studio/WatermarkController.php:35
* @route '/studio/watermark'
*/
show.url = (options?: RouteQueryOptions) => {
    return show.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Studio\WatermarkController::show
* @see app/Http/Controllers/Studio/WatermarkController.php:35
* @route '/studio/watermark'
*/
show.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Studio\WatermarkController::show
* @see app/Http/Controllers/Studio/WatermarkController.php:35
* @route '/studio/watermark'
*/
show.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Studio\WatermarkController::show
* @see app/Http/Controllers/Studio/WatermarkController.php:35
* @route '/studio/watermark'
*/
const showForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Studio\WatermarkController::show
* @see app/Http/Controllers/Studio/WatermarkController.php:35
* @route '/studio/watermark'
*/
showForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Studio\WatermarkController::show
* @see app/Http/Controllers/Studio/WatermarkController.php:35
* @route '/studio/watermark'
*/
showForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Studio\WatermarkController::image
* @see app/Http/Controllers/Studio/WatermarkController.php:61
* @route '/studio/watermark/obrazek'
*/
export const image = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: image.url(options),
    method: 'get',
})

image.definition = {
    methods: ["get","head"],
    url: '/studio/watermark/obrazek',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Studio\WatermarkController::image
* @see app/Http/Controllers/Studio/WatermarkController.php:61
* @route '/studio/watermark/obrazek'
*/
image.url = (options?: RouteQueryOptions) => {
    return image.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Studio\WatermarkController::image
* @see app/Http/Controllers/Studio/WatermarkController.php:61
* @route '/studio/watermark/obrazek'
*/
image.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: image.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Studio\WatermarkController::image
* @see app/Http/Controllers/Studio/WatermarkController.php:61
* @route '/studio/watermark/obrazek'
*/
image.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: image.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Studio\WatermarkController::image
* @see app/Http/Controllers/Studio/WatermarkController.php:61
* @route '/studio/watermark/obrazek'
*/
const imageForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: image.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Studio\WatermarkController::image
* @see app/Http/Controllers/Studio/WatermarkController.php:61
* @route '/studio/watermark/obrazek'
*/
imageForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: image.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Studio\WatermarkController::image
* @see app/Http/Controllers/Studio/WatermarkController.php:61
* @route '/studio/watermark/obrazek'
*/
imageForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: image.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

image.form = imageForm

/**
* @see \App\Http\Controllers\Studio\WatermarkController::store
* @see app/Http/Controllers/Studio/WatermarkController.php:74
* @route '/studio/watermark'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/studio/watermark',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Studio\WatermarkController::store
* @see app/Http/Controllers/Studio/WatermarkController.php:74
* @route '/studio/watermark'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Studio\WatermarkController::store
* @see app/Http/Controllers/Studio/WatermarkController.php:74
* @route '/studio/watermark'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Studio\WatermarkController::store
* @see app/Http/Controllers/Studio/WatermarkController.php:74
* @route '/studio/watermark'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Studio\WatermarkController::store
* @see app/Http/Controllers/Studio/WatermarkController.php:74
* @route '/studio/watermark'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Studio\WatermarkController::destroy
* @see app/Http/Controllers/Studio/WatermarkController.php:121
* @route '/studio/watermark'
*/
export const destroy = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/studio/watermark',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Studio\WatermarkController::destroy
* @see app/Http/Controllers/Studio/WatermarkController.php:121
* @route '/studio/watermark'
*/
destroy.url = (options?: RouteQueryOptions) => {
    return destroy.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Studio\WatermarkController::destroy
* @see app/Http/Controllers/Studio/WatermarkController.php:121
* @route '/studio/watermark'
*/
destroy.delete = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Studio\WatermarkController::destroy
* @see app/Http/Controllers/Studio/WatermarkController.php:121
* @route '/studio/watermark'
*/
const destroyForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Studio\WatermarkController::destroy
* @see app/Http/Controllers/Studio/WatermarkController.php:121
* @route '/studio/watermark'
*/
destroyForm.delete = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const watermarks = {
    show: Object.assign(show, show),
    image: Object.assign(image, image),
    store: Object.assign(store, store),
    destroy: Object.assign(destroy, destroy),
}

export default watermarks